import { useState } from 'react';
import { Button, Alert } from 'react-bootstrap';

export function AlertDismissible({
  message,
  title,
  variant,
  onClose = () => {},
  buttonLabel = 'close',
  ...props
}) {
  const [show, setShow] = useState(true);

  return (
    <>
      <Alert show={show} variant={variant} {...props}>
        <Alert.Heading>{title}</Alert.Heading>
        <p>{message}</p>
        <hr />
        <div className="d-flex justify-content-end">
          <Button
            onClick={() => {
              setShow(false);
              onClose();
            }}
            variant={`outline-${variant}`}
          >
            {buttonLabel}
          </Button>
        </div>
      </Alert>
    </>
  );
}
